import * as LanguageRepository from "./LanguageRepository";

export const getLanguages = async (route: string) => {
  return LanguageRepository.getLanguages(route);
};
